import { useStyletron } from "baseui";
import { Check } from "baseui/icon";
import React from "react";
import { useNavigate } from "react-router-dom";
import { useDeleteResourceGroupMutation } from "../../../services/resourceGroups/resourceGroupApi";
import { Modal, ModalBody, ModalButton, ModalFooter, ModalHeader } from "baseui/modal";
import { Banner } from "baseui/banner";
import { IResourceGroup } from "@oqdo/automationapps/Memberships/ResourceGroup";
import { useReportMutationState } from "../../../hooks/useReportMutationState";

interface RDeleteGroupDialogProps {
  resourceGroup: IResourceGroup;
  isOpen: boolean;
  setIsOpen: any;
  subscriptionId: string;
}
function DeleteGroupDialog({ resourceGroup, isOpen, setIsOpen, subscriptionId }: RDeleteGroupDialogProps) {
  const [css, theme] = useStyletron();
  const [del, delResult] = useDeleteResourceGroupMutation();
  useReportMutationState(delResult, () => setIsOpen(false), {
    message: "Successfully deleted",
    startEnhancer: ({ size }) => <Check size={size} />,
    actionMessage: "Go back",
    actionOnClick: () => {
      navigate("/subscriptions/" + subscriptionId);
    },
  });

  const navigate = useNavigate();

  function close() {
    setIsOpen(false);
  }

  async function deleteRg() {
    await del(resourceGroup.id);
  }

  return (
    <React.Fragment>
      <Modal onClose={close} isOpen={isOpen}>
        <ModalHeader>Delete '{resourceGroup.name}'</ModalHeader>
        <ModalBody>
          <>
            <Banner kind="warning">
              Deleting a Resource Group will <b>remove all Apps</b> that exist in that ResourceGroup.
              <br />
              <br />
              You can not revert this step!
            </Banner>
          </>
        </ModalBody>
        <ModalFooter>
          <ModalButton kind="tertiary" onClick={close}>
            Cancel
          </ModalButton>
          <ModalButton isLoading={delResult.isLoading} onClick={deleteRg}>
            Okay
          </ModalButton>
        </ModalFooter>
      </Modal>
    </React.Fragment>
  );
}

export default DeleteGroupDialog;
